import React from 'react';

const ImpressumContent = () => {
  return (
    <div className="font-light text-gray-600 leading-relaxed">
      <h3 className="text-gray-800 font-normal mb-4">Angaben gemäß § 5 TMG</h3>
      <p className="mb-6">
        Nadine Rau u. Mike Trepte GbR<br />
        Bettenhäuserstr. 1<br />
        34123 Kassel<br />
        Deutschland
      </p>

      <h3 className="text-gray-800 font-normal mb-2">Geschäftsführer</h3>
      <p className="mb-6">Nadine Rau, Mike Trepte</p>

      <h3 className="text-gray-800 font-normal mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
      <p className="mb-6">Mike Trepte</p>

      <h3 className="text-gray-800 font-normal mb-2">Kontakt</h3>
      <p className="mb-6">
        Telefon: 0561 / 43027276<br />
        E-Mail: mike.trepte@underopensky.de
      </p>

      <p className="mb-6">Standort: Kassel, Deutschland</p>

      <h3 className="text-gray-800 font-normal mb-2">Umsatzsteuer-ID</h3>
      <p className="mb-6">Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE338605405</p>

      <h3 className="text-gray-800 font-normal mb-2">Redaktionell verantwortlich</h3>
      <p className="mb-10">
        Mike Trepte<br />
        Bettenhäuserstr. 1<br />
        34123 Kassel
      </p>

      <div className="space-y-6 text-sm text-gray-500 border-t border-gray-100 pt-8">
        <section>
          <h4 className="text-gray-800 font-normal mb-2">Haftung für Inhalte</h4>
          <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
        </section>

        <section>
          <h4 className="text-gray-800 font-normal mb-2">Haftung für Links</h4>
          <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
        </section>

        <section>
          <h4 className="text-gray-800 font-normal mb-2">Urheberrecht</h4>
          <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
        </section>
      </div>
    </div>
  );
};

export default ImpressumContent;